import { render, staticRenderFns } from "./companyInfoStyle.vue?vue&type=template&id=1e837125&scoped=true"
import script from "./companyInfoStyle.vue?vue&type=script&lang=js"
export * from "./companyInfoStyle.vue?vue&type=script&lang=js"
import style0 from "./companyInfoStyle.vue?vue&type=style&index=0&id=1e837125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e837125",
  null
  
)

export default component.exports